import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ModalController, NavController, NavParams, Platform } from '@ionic/angular';
import { isPresent } from 'src/providers/common-service';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { adjustViewZIndex } from 'src/globals';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import {
  CompetitionCategory,
  CompetitionInfo,
  CompetitionPrizeInfo,
  GameroundPrize,
} from './../../../../data/competition-data';
import { LeagueRound, LeagueSeason } from './../../../../data/mygolf.data';
import { Location } from '@angular/common';

import * as global from 'src/globals';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import {
  InAppBrowser,
  InAppBrowserOptions,
  InAppBrowserEvent,
} from '@awesome-cordova-plugins/in-app-browser/ngx';

import { Browser } from '@capacitor/browser';
@Component({
  selector: 'app-competition-league-menu',
  templateUrl: './competition-league-menu.page.html',
  styleUrls: ['./competition-league-menu.page.scss'],
})
export class CompetitionLeagueMenuPage implements OnInit {
  @Input() public competition: CompetitionInfo;
  public prizes: Array<CompetitionPrizeInfo>;
  public roundNo: Array<number> = new Array<number>();
  public prizeMap: any = {};
  public compPrizes: Array<CompetitionPrizeInfo> = [];
  public roundwisePrizes: Array<Array<CompetitionPrizeInfo>> = [];
  public categories: Array<CompetitionCategory> = new Array<CompetitionCategory>();

  public gameRoundPrizes: Array<GameroundPrize> = [];

  public teamRoundwisePrizes: Array<Array<CompetitionPrizeInfo>> = [];
  public teamPrizes: Array<CompetitionPrizeInfo>;
  public compTeamPrizes: Array<CompetitionPrizeInfo> = [];
  public gameRoundTeamPrizes: Array<GameroundPrize> = [];

  isEclectic: boolean = false;
  @Input() compSeasonId: number;

  leagueRounds: Array<LeagueRound>;

  @Input() leagueSeasons: Array<LeagueSeason> = [];
  compId: number;
  appLeaderboardURLs: Array<any> = [];

  options: InAppBrowserOptions = {
    location: 'yes',
    hidden: 'no',
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no',
    closebuttoncaption: 'Close',
    disallowoverscroll: 'no',
    toolbar: 'yes',
    enableViewportScale: 'no',
    allowInlineMediaPlayback: 'no',
    presentationstyle: 'pagesheet',
    fullscreen: 'yes',
  };
  constructor(
    private router: Router,
    private nav: NavController,
    private navParams: NavParams,
    private renderer: Renderer2,
    private competitionService: CompetitionService,
    private flightService: ClubFlightService,
    public route: ActivatedRoute,
    private location: Location,
    private modalCtrl: ModalController,
    private mg2uUtils: mygolfUtils,
    private platform: Platform,
    private iab: InAppBrowser
  ) {
    if (!this.router.getCurrentNavigation()?.extras?.state) {
      // this.onHomeClick()
    }

    if (this.router.getCurrentNavigation()?.extras) {
      this.competition = this.router.getCurrentNavigation()?.extras?.state.competition;
      this.prizes = this.router.getCurrentNavigation()?.extras?.state.prizes;
      this.teamPrizes = this.router.getCurrentNavigation()?.extras?.state.teamPrizes;
      this.categories = this.router.getCurrentNavigation()?.extras?.state.categories;
      this.leagueSeasons = this.router.getCurrentNavigation()?.extras.state.leagueSeasons;
      this.compSeasonId = this.router.getCurrentNavigation()?.extras.state.compSeasonId;
      if (this.leagueSeasons) {
        this.leagueSeasons.sort((a, b) => {
          if (a.leagueType === 'Eclectic' && b.leagueType !== 'Eclectic') return -1;
          else if (a.leagueType !== 'Eclectic' && b.leagueType === 'Eclectic') return 1;
          else return 0;
        });
      }
    }
    this.prizeMap = {};
    if (this.competition) this.compId = this.competition.competitionId;
    this.appLeaderboardURLs = this.mg2uUtils.getAppAttribute()?.filter(attr => {
      return attr?.page === 'competition';
    })[0].leagueLeaderboard;
    // .map((attr)=>{
    //   return attr?.leagueLeaderboard;
    // })
    console.debug('app leaderboard urls [0] : ', this.appLeaderboardURLs);
    console.debug('app leaderboard urls [1] : ', this.mg2uUtils.getAppAttribute());
  }

  ngOnInit() {}

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
    // this.competition? this.competition.competitionId : this.compId
    // this.flightService.checkLeagueCompetition(this.competition.competitionId)
    //   .subscribe((data)=>{

    //     this.isEclectic = data;
    //     this.getLeagueSeason();
    //   })
  }

  onHomeClick() {
    this.router.navigate(['tabs/player-home']);
  }

  isCompetitionEclectic() {
    return this.isEclectic;
  }

  onBackpage() {
    // this.modalCtrl.dismiss();
    this.location.back();
    // this.router.navigate(['tabs/competition-details']);
  }

  goLeagueScorecard(appLocal?: boolean) {
    let _url = '/public/eclectic-scorecards/:compId?seasonId=:seasonId&hideLogin=true';

    console.debug('scorecard url : ', this.appLeaderboardURLs);

    if (this.appLeaderboardURLs?.length && !appLocal) {
      let lbAttr = this.appLeaderboardURLs.filter(lb => {
        console.debug('filtering ', lb);
        return lb?.type === 'EclecticScorecards' && lb?.enable;
      })[0];

      let reCompId = /:compId/gi;
      let reSeasonId = /:seasonId/gi;
      console.debug('scorecard url : ', lbAttr, _url);
      if (lbAttr?.publicURL) {
        _url = lbAttr?.publicURL;

        _url = _url.replace(reCompId, String(this.compId));
        _url = _url.replace(reSeasonId, String(this.compSeasonId));
        _url = global.MygolfPortal + _url;
        console.debug('scorecard url 2 : ', _url);
        this.openExternalURL(_url);
        return;
      }
      // else {
      //   _url = _url.replace(reCompId, String(this.compId));
      //   _url = _url.replace(reSeasonId, String(this.compSeasonId));
      //   _url = global.MygolfPortal + _url;
      //   console.debug("scorecard url 2 : ", _url)
      //   this.openExternalURL(_url)
      //   return;
      // }
    }
    if (_url?.length) return;
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
      },
    };
    this.router.navigate(['tabs/competition-league-scorecard'], navigationExtras);
  }
  goEclecticLeaderboard(appLocal?: boolean) {
    let _url = '/public/eclectic-leaderboard/:compId?seasonId=:seasonId&hideLogin=true';
    if (this.appLeaderboardURLs?.length && !appLocal) {
      let lbAttr = this.appLeaderboardURLs.filter(lb => {
        return lb?.type === 'EclecticLeaderboard' && lb?.enable;
      })[0];

      if (lbAttr?.publicURL) {
        _url = lbAttr?.publicURL;
        let reCompId = /:compId/gi;
        let reSeasonId = /:seasonId/gi;

        _url = _url.replace(reCompId, String(this.compId));
        _url = _url.replace(reSeasonId, String(this.compSeasonId));
        _url = global.MygolfPortal + _url;
        this.openExternalURL(_url);
        return;
      }
    }
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
        leagueType: 'Eclectic',
      },
    };
    this.router.navigate(['tabs/competition-league-leaderboard'], navigationExtras);
  }

  goLeagueLowestLeaderboard(appLocal?: boolean) {
    let _url = '/public/eclectic-lowest-gross-leaderboard?seasonId=:seasonId&hideLogin=true';
    if (this.appLeaderboardURLs?.length && !appLocal) {
      let lbAttr = this.appLeaderboardURLs.filter(lb => {
        return lb?.type === 'EclecticLowest' && lb?.enable;
      })[0];

      if (lbAttr?.publicURL) {
        _url = lbAttr?.publicURL;
        let reCompId = /:compId/gi;
        let reSeasonId = /:seasonId/gi;

        _url = _url.replace(reCompId, String(this.compId));
        _url = _url.replace(reSeasonId, String(this.compSeasonId));
        _url = global.MygolfPortal + _url;
        this.openExternalURL(_url);
        return;
      }
    }
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
      },
    };
    this.router.navigate(['tabs/competition-league-lowest'], navigationExtras);
  }

  goLeagueLeaderboard(league: LeagueSeason, appLocal?: boolean) {
    if (!league) return;
    let _url = '/public/order-of-merit-leaderboard?seasonId=:seasonId&hideLogin=true';
    if (this.appLeaderboardURLs?.length && !appLocal) {
      let lbAttr = this.appLeaderboardURLs.filter(lb => {
        return lb?.type === 'Positional' && lb?.enable;
      })[0];

      if (lbAttr?.publicURL) {
        _url = lbAttr?.publicURL;
        let reSeasonId = /:seasonId/gi;

        _url = _url.replace(reSeasonId, String(league.id));
        _url = global.MygolfPortal + _url;
        this.openExternalURL(_url);
        return;
      }
    }
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        leagueSeason: league,
        compSeasonId: league?.id,
        leagueType: 'Positional',
      },
    };
    this.router.navigate(['tabs/competition-league-leaderboard'], navigationExtras);
  }

  getLeagueSeason() {
    this.flightService.getLeagueSeason(this.competition.competitionId).subscribe(data => {
      this.compSeasonId = data;
      this.getLeagueRounds(data);
      // this.refreshLeagueScorecards(this.competition.competitionId);
    });
  }

  getLeagueRounds(seasonId: number) {
    this.flightService.getLeagueRounds(seasonId).subscribe(data => {
      if (data) this.leagueRounds = data;
    });
  }

  //
  goHome() {
    this.router.navigate(['tabs/player-home']);
  }

  getLeagueImage(league: LeagueSeason) {
    // console.debug("get club image [0] : ", this.clubMembership)
    if (!league) return 'assets/image/icons/leaderboard_4x.png';
    let _leagueImage = '';
    if (league?.league?.leagueImage) _leagueImage = league?.league?.leagueImage;
    else return 'assets/image/icons/leaderboard_4x.png';

    // console.debug("get club image [1] : ", _clubImage)
    if (_leagueImage.toLowerCase().includes(global.MygolfPortal.toLowerCase())) return _leagueImage;
    else return global.MygolfServer + '/' + _leagueImage;
  }

  async onImageClick() {
    // let modal = await this.modalCtl.create({
    //   component: ExpandCompetitionLogo,
    //   cssClass: 'self-adjustable-modal',
    //   componentProps: {
    //     competition: this.competition,
    //     compId: this.compId,
    //   },
    // });
    // await modal.present();
  }

  openExternalURL(url: string, target?: string) {
    let _options =
      'location=no,toolbar=yes,fullscreen=yes,height=800,width=480,hidden=yes,clearcache=yes';
    if (this.platform.is('mobile') && this.platform.is('capacitor')) {
      let _target;
      if (target) _target = target;
      else _target = '_blank';
      if (this.platform.is('ios')) {
        _target = '_blank';
        Browser.open({ url: url });
        return;
      }
      let _iab = this.iab.create(url, _target, this.options);

      if (this.platform.is('ios')) {
        _iab.on('loadstart').subscribe(event => {
          let loc = event.url.toLowerCase();
          // if (loc.includes(this.paymentRedirectURL.toLowerCase())) {
          //   setTimeout(function () {
          //     _iab.close();
          //   }, 5000);
          // }
        });
      } else {
        _iab.on('loadstop').subscribe(event => {
          let loc = event.url.toLowerCase();
          // if (loc.includes(this.paymentRedirectURL)) {
          //   setTimeout(function () {
          //     _iab.close();
          //   }, 5000);
          // }
        });
      }
      _iab.on('exit').subscribe(
        () => {
          // if (attribute === 'getBill') {
          //   if (this.selectPaymentMethod.toLowerCase().includes('billplz')) {
          //     this.getBill(data.id, 'billplz');
          //   } else if (this.selectPaymentMethod.toLowerCase().includes('ipay88'))
          //     this.getBill(data.bill, 'ipay88');
          // }
        },
        err => {}
      );
    } else window.open(url, '_system', _options);
  }

  isAppLocal() {
    return global.devMode;
  }
}
